var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 32,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7cda1a4578"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 178.351562 88 L 571.351562 88 L 571.351562 603.75 L 178.351562 603.75 Z M 178.351562 88 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7cda1a4578)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 571.210938 345.695312 C 571.199219 320.296875 551.382812 299.597656 526.390625 298.066406 L 287.96875 298.066406 L 277.503906 246.554688 C 267.128906 199.214844 297.179688 152.25 344.484375 141.867188 C 391.792969 131.488281 438.726562 161.558594 449.101562 208.894531 L 454.550781 236.863281 C 456.4375 245.441406 464.910156 250.867188 473.488281 248.992188 L 492.488281 244.828125 C 501.078125 242.949219 506.515625 234.449219 504.625 225.855469 L 499.175781 197.894531 C 482.742188 122.921875 408.417969 75.308594 333.496094 91.753906 C 258.574219 108.199219 210.988281 182.5625 227.425781 257.542969 L 235.65625 298.066406 L 226.101562 298.066406 C 199.714844 298.074219 178.332031 319.492188 178.351562 345.894531 L 178.390625 555.679688 C 178.402344 582.085938 199.804688 603.480469 226.191406 603.464844 L 523.5 603.316406 C 549.886719 603.300781 571.269531 581.886719 571.25 555.480469 Z M 387.871094 458.941406 L 387.902344 518.359375 L 366.253906 518.371094 L 366.226562 458.953125 C 354.328125 454.539062 345.800781 443.183594 345.792969 429.742188 C 345.78125 412.480469 359.769531 398.476562 377.019531 398.46875 C 394.273438 398.457031 408.265625 412.453125 408.273438 429.714844 C 408.28125 443.148438 399.761719 454.515625 387.871094 458.941406 Z M 387.871094 458.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.a74af8c2390f3f3a4d05b08d39a659a6.svg";
export { ForwardRef as ReactComponent };